import { useNavigate } from '@tanstack/react-router';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { useDisciplineEdit } from '@/module/Discipline/model/DisciplineQuery';
import {
  DisciplineSchema,
  defaultDisciplineValues,
  disciplineSchema,
} from '@/module/Discipline/model/DisciplineSchema';

import { useAppNotification } from '@feature/utils';

import { DisciplineForm } from './DisciplineForm';
import { Discipline } from './model/DisciplineTypes';

interface DisciplineEditProps {
  discipline: Discipline;
}

const convert = (discipline: Discipline): DisciplineSchema => ({
  ...discipline,
});

export function DisciplineEdit(props: DisciplineEditProps) {
  const { discipline } = props;
  const { t } = useTranslation();
  const { mutate, isPending, isError, isSuccess } = useDisciplineEdit(discipline.id);

  const notification = useAppNotification();
  const onSubmit = (values: DisciplineSchema) => {
    mutate(values, {
      onError: notification.error,
      onSuccess: notification.success,
    });
  };

  const values = useMemo(() => convert(discipline), [discipline]);
  const navigate = useNavigate();

  return (
    <DisciplineForm
      title={t('disciplines.form.title.edit')}
      schema={disciplineSchema}
      defaultValues={defaultDisciplineValues}
      isError={isError}
      isSuccess={isSuccess}
      values={values}
      onSubmit={onSubmit}
      isSubmitting={isPending}
      onCancel={() => navigate({ to: '..' })}
    />
  );
}
